import { Component, Input, OnChanges } from '@angular/core';

import { Person } from '../shared/models/person.model';
import { GraphPictureService } from '../shared/services/graph-picture.service';

import './person-picture.component.css';

@Component({
    selector: 'ohp-person-picture',
    templateUrl: './person-picture.component.html'
})
export class PersonPictureComponent implements OnChanges {
    @Input() public person: Person | undefined;

    @Input() public pictureId: string;

    @Input() public fetchImage: boolean = true;

    @Input() public imageBase64: string;

    @Input() public isUpcomingMeeting: boolean = false;

    @Input() public status: 'None' | 'Accepted' | 'Declined' | 'TentativelyAccepted' = 'None';

    @Input() public iconSize: number;

    @Input() public hasPadding: boolean = false;

    @Input() public personPictureCard: boolean = false; // Used for when the person picture is in the activity description header of a card

    public imageBase64Promise: Promise<string>;

    constructor(
        private readonly graphPictureService: GraphPictureService
    ) {
        this.iconSize = this.iconSize || 30;
    }

    public ngOnChanges() {
        const pictureSize = this.iconSize <= 48 ? '48x48' : undefined;
        if (this.fetchImage) {
            const pictureId = this.pictureId || this.person?.email;
            this.imageBase64Promise = pictureId ? this.graphPictureService.getPeoplePicture(pictureId, pictureSize) : Promise.resolve(null);
        } else {
            this.imageBase64Promise = Promise.resolve(this.imageBase64);
        }
    }
}
